var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvertSelection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6830_82044)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6587 22.0898V9.0426L25.8583 12.2422C26.1267 12.5105 26.5617 12.5105 26.83 12.2422C27.0983 11.9739 27.0983 11.5388 26.83 11.2705L22.4575 6.89802C22.1892 6.6297 21.7541 6.6297 21.4858 6.89802L17.1133 11.2705C16.845 11.5388 16.845 11.9739 17.1133 12.2422C17.3816 12.5105 17.8166 12.5105 18.085 12.2422L21.2846 9.0426L21.2846 22.0898L22.6587 22.0898ZM10.2195 11.3796V24.9851L6.9775 21.7431C6.70563 21.4712 6.26484 21.4712 5.99297 21.7431C5.72109 22.015 5.72109 22.4558 5.99297 22.7276L10.4234 27.158C10.6953 27.4299 11.136 27.4299 11.4079 27.158L15.8383 22.7276C16.1102 22.4558 16.1102 22.015 15.8383 21.7431C15.5665 21.4712 15.1257 21.4712 14.8538 21.7431L11.6118 24.9851V11.3796H10.2195Z",
    fill: "#6621F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6830_82044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.40625 0.955078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertSelection);
export default __webpack_public_path__ + "static/media/invert-selection.cc9d73798083b2f763643de3fc59dd37.svg";
export { ForwardRef as ReactComponent };